export function getMSNIcon(msn_type_id = 0) {
  let typeIconMap = {
    1: 'container',
    2: 'noContainer',
    3: 'separate',
  }
  return typeIconMap[`${msn_type_id}`] || 'container'
}

export function getGarbageIcon(garbage_source_type_id = 0) {
  let typeIconMap = {
    1: 'uk',
    2: 'org',
    3: 'set',
    4: 'def',
    5: 'med',
    6: 'ind',
    7: 'country',
    8: 'gsk',
    9: 'apartmentBuildings',
    10: 'dep',
    11: 'fac',
    12: 'dor',
    14: 'educational',
    15: 'health-resort',
    16: 'animal-husbandry',
    17: 'recreation-purpose',
    18: 'agricultural-purpose',
    19: 'construction',
    20: 'trade',
    21: 'transport-infrastructure',
    22: 'household',
    23: 'catering',
    24: 'culture',
    25: 'admin_building',
    26: 'other',
    27: 'no_type',
  }
  return typeIconMap[`${garbage_source_type_id}`] || 'country'
}

export function getTkoIcon(tko_action_id = 0) {
  let typeIconMap = {
    1: 'garbage',
    2: 'process',
    3: 'neutral',
    4: 'storage',
    5: 'util',
    6: 'burial',
    7: 'garbage',
  }
  return typeIconMap[`${tko_action_id}`] || 'garbage'
}
